import {Pagination, Table, Tag, Typography} from "antd";
import {Button, Icon, Image, PopperUserInfo} from "~/components";
import {renderDateTime} from "~/utils";
import {describeCron} from "../../utils/cronReview";

function CronJobTable({items = [], pagination, onPaginationChange, openModal, setItemEdit})
{
    const columns = [
        {
            title: 'Cron time',
            dataIndex: 'crontime',
            key: 'crontime',
            width: 150,
            render: (_, item) => <Tag color="blue">{item.crontime}</Tag>,
        },
        {
            title: 'Review',
            dataIndex: 'description',
            key: 'description',
            width: 220,
            render: (_, item) => <span>{describeCron(item)}</span>,
        },
        {
            title: 'Webhook URL',
            dataIndex: 'url',
            key: 'url',
            render: (_, item) => <Typography.Paragraph copyable ellipsis={{rows: 2}}>{item.url}</Typography.Paragraph>,
        },
        {
            title: 'Server ID',
            dataIndex: 'cronjobId',
            key: 'cronjobId',
            width: 220,
            render: (_, item) => <Typography.Paragraph copyable ellipsis>{item.cronjobId}</Typography.Paragraph>,
        },
        {
            title: 'Người tạo',
            dataIndex: 'user',
            key: 'user',
            width: 160,
            render: (_, item) => item.user?.id && (
                <PopperUserInfo user={item.user}>
                    <div className="d-flex gap align-items">
                        <div className="avatar"><Image src={item.user?.avatar} /></div>
                        <div>
                            <b>{item.user?.lastname}</b>
                            <p>{item.user?.username}</p>
                        </div>
                    </div>
                </PopperUserInfo>
            ),
        },
        {
            title: 'Created',
            dataIndex: 'created',
            key: 'created',
            width: 150,
            render: (_, item) => <span>{renderDateTime(item.created)}</span>,
        },
        {
            title: '#',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            render: (_, item) => (
                <Button
                    background
                    red
                    small
                    leftIcon={Icon.delete}
                    onClick={() => {
                        setItemEdit(item);
                        openModal('delete');
                    }}
                >Xoa</Button>
            ),
        },
    ];

    const dataSource = items.map((row) => ({key: row.id, ...row}));

    return (
        <div className="table-wrapper">
            <div className="table-box">
                <Table columns={columns} dataSource={dataSource} scroll={{y: 550}} pagination={false} />
            </div>
            <Pagination
                current={pagination.page}
                defaultCurrent={1}
                defaultPageSize={20}
                pageSize={pagination.limit}
                total={pagination.total}
                onChange={onPaginationChange}
                showSizeChanger={false}
            />
        </div>
    );
}

export default CronJobTable;
